import SuiTypography from "components/SuiTypography";
import TableAction from "containers/table-action";
import { CircularProgress, Tooltip } from "@mui/material";
import {
  calculateProductTotalBalance,
  calculateProductFinalPrice,
} from "utils/common";
import { globaleDateTimeFormatter } from "utils/helper";
import SuiBox from "components/SuiBox";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import RestorePageIcon from "@mui/icons-material/RestorePage";

export const productRow = (
  productArray,
  navigate,
  setInvoiceDataHandler,
  viewHandler,
  loading,
  formdata,
  setFormdata,
  editHandler
) => {
  const rows = productArray.map((item, index) => {
    return {
      "S.no": (
        <SuiTypography
          variant="button"
          fontWeight="medium"
          style={{ paddingLeft: 14 }}
        >
          {index + 1}
        </SuiTypography>
      ),

      "Client Name": (
        <SuiTypography
          variant="button"
          fontWeight="medium"
          style={{
            color: "#17C1E8",
            cursor: "pointer",
          }}
          onClick={() => {
            navigate(`/clients/${item.clientId}`);
          }}
        >
          {item.name}
        </SuiTypography>
      ),

      "Customer ID": (
        <SuiTypography variant="button" fontWeight="medium">
          {item.customerId ?? "N/A"}
        </SuiTypography>
      ),

      "Selling Date/Time": (
        <SuiTypography variant="button" fontWeight="medium">
          {globaleDateTimeFormatter(item?.purchasedAt)}
        </SuiTypography>
      ),

      Product: (
        <SuiTypography variant="button" fontWeight="medium">
          {item?.productName}
        </SuiTypography>
      ),

      Email: (
        <SuiTypography variant="button" fontWeight="medium">
          {item?.email}
        </SuiTypography>
      ),

      Brand: (
        <SuiTypography variant="button" fontWeight="medium">
          {item?.brand}
        </SuiTypography>
      ),

      "Total Amount": (
        <SuiTypography variant="button" fontWeight="medium">
          {calculateProductFinalPrice(
            item.quantity,
            item.sellingPriceWOT,
            item.discount,
            item.clientGst ? item.clientGst : item.gst
          )}
        </SuiTypography>
      ),

      Discount: (
        <SuiTypography variant="button" fontWeight="medium">
          {item?.discount}
        </SuiTypography>
      ),

      Quantity: (
        <SuiTypography variant="button" fontWeight="medium">
          {item?.quantity}
        </SuiTypography>
      ),

      "Amount Paid": (
        <SuiTypography variant="button" fontWeight="medium">
          {item?.amountPaid ?? 0}
        </SuiTypography>
      ),

      Balance: (
        <SuiTypography
          style={{ paddingLeft: 0, color: "red" }}
          variant="button"
          fontWeight="medium"
        >
          INR{" "}
          {calculateProductTotalBalance(
            item.sellingPriceWOT,
            item.quantity,
            item.discount,
            item.clientGst ? item.clientGst : item.gst,
            item.amountPaid
          )}
        </SuiTypography>
      ),

      Action: (
        <SuiBox style={{ display: "flex", alignItems: "center" }}>
          {/* <TableAction
            style={{ marginLeft: "7px" }}
            viewHandler={() => viewHandler(item, "product")}
          /> */}
          {loading === index ? (
            <CircularProgress color="success" size={"1rem"} />
          ) : (
            <Tooltip title="Create Invoice" placement="top">
              <NoteAddIcon
                variant="button"
                fontWeight="medium"
                style={{
                  color: "#17C1E8",
                  cursor: "pointer",
                  paddingLeft: 8,
                }}
                onClick={() => editHandler(item, "product")}
                fontSize="large"
              >
                Create invoice{" "}
              </NoteAddIcon>
            </Tooltip>
          )}
          <Tooltip title="Invoice History" placement="top">
            <RestorePageIcon
              variant="button"
              fontWeight="medium"
              style={{
                color: "#17C1E8",
                cursor: "pointer",
                paddingLeft: 8,
              }}
              onClick={() => {
                setInvoiceDataHandler(
                  item.name,
                  item.productName,
                  item.id,
                  "products",
                  item.clientId
                );
              }}
              fontSize="large"
            >
              Invoice history
            </RestorePageIcon>
          </Tooltip>
        </SuiBox>
      ),
    };
  });
  return rows;
};
